import * as i18nInterface from './i18n-interface';

import { ctrlAboutTheContainer, ctrlAdviseLocation, ctrlCarriage, ctrlCarriagePosition, ctrlCassetteCode, ctrlCassetteLocation, ctrlConstructionDate, ctrlContainerLength, ctrlContainerNumber, ctrlContainerPrefix, ctrlContainerSearch, ctrlContainerSize, ctrlContainerSummary, ctrlCopyFromBooking, ctrlDefrostInterval, ctrlDrains, ctrlEditValues, ctrlEnableAppointmentStats, ctrlEnableEquipmentStats, ctrlEnableOrders, ctrlEnableQuayjobs, ctrlExtraPti, ctrlGrossWeight, ctrlGrossWeightDeviation, ctrlHumidity, ctrlIsCassette, ctrlLocation, ctrlNewLocation, ctrlPortOfDischarge, ctrlPortOfDischargeTerminal, ctrlReeferChecks, ctrlReeferTemperature, ctrlReeferTemperatureMax, ctrlReeferTemperatureMin, ctrlRepairInfo, ctrlSealNrTerminal, ctrlShowFilters, ctrlSorting, ctrlStowLocation, ctrlVentilation, ctrlVentilationUnit, ctrlVentilationValue, sectionActions, sectionAdviseLocation, sectionCassette, sectionCassetteCode, sectionContainerFilter, sectionContainerList, sectionContainerNumber, sectionContainerSummary, sectionEditValues, sectionFilters, sectionLocation, sectionNewLocation, sectionOrderDetails, sectionReadonlyContainer, sectionReeferChecks, sectionRegistration, sectionRepairInfo, sectionStowLocation, sectionTrainCarriage } from '../ctrls/ctrls-constants';
import { textMyOrders, textNewSearch, textNotSet, textSurvey } from './i18n-interface';

import { I18NLanguage } from './i18n-language';

export class I18NText {
  static [I18NLanguage.english]: i18nInterface.I18NTextI = {
    [i18nInterface.textActionAlreadyInProgress]: 'An action is already in progress',
    [i18nInterface.textAdvisedQuayjob]: 'advised quayjob',
    [i18nInterface.textXNotApplicableShort]: '{{ x }} N/A',
    [i18nInterface.textHousekeeping]: 'housekeeping',
    [i18nInterface.textQuayToStack]: 'quay to stack',
    [i18nInterface.textShuffle]: 'shuffle',
    [i18nInterface.textStackToQuay]: 'stack to quay',
    [i18nInterface.textStackToWarehouse]: 'stack to warehouse',
    [i18nInterface.textWarehouseToStack]: 'warehouse to stack',
    [i18nInterface.textInternalTransportToStack]: 'internal transport to stack',
    [i18nInterface.textShunt]: 'shunt',
    [i18nInterface.textStackToInternalTransport]: 'stack to internal transport',
    [textSurvey]: 'survey',
    [i18nInterface.textReeferNeedsPlugin]: 'needs plug-in',
    [textMyOrders]: 'my orders',
    [i18nInterface.textQuery]: 'query',
    [i18nInterface.textLog]: 'log',
    [i18nInterface.textOpenLog]: 'open log',
    [i18nInterface.textCancelMove]: 'cancel move',
    [i18nInterface.loadingCheckLocation]: 'checking location',
    [i18nInterface.loadingStkSearch]: 'loading (001)',
    [i18nInterface.loadingMafBundle]: 'loading (002)',
    [i18nInterface.loadingMafGet]: 'loading (003)',
    [i18nInterface.loadingMafLoadQuay]: 'loading (004)',
    [i18nInterface.loadingMafLtcRemove]: 'loading (005)',
    [i18nInterface.loadingMafLtcSave]: 'loading (006)',
    [i18nInterface.loadingOrdContainerSearch]: 'loading (007)',
    [i18nInterface.loadingOrdDetails]: 'loading (008)',
    [i18nInterface.loadingOrdProcess]: 'loading (009)',
    [i18nInterface.loadingOrdReset]: 'loading (010)',
    [i18nInterface.loadingQuaCarriage]: 'loading (011)',
    [i18nInterface.loadingQuaDetails]: 'loading (012)',
    [i18nInterface.loadingQuaDischarge]: 'loading (013)',
    [i18nInterface.loadingQuaFullLoadingList]: 'loading (014)',
    [i18nInterface.loadingQuaLoading]: 'loading (015)',
    [i18nInterface.loadingRelSave]: 'saving relocate',
    [i18nInterface.loadingRfrMonSave]: 'loading (017)',
    [i18nInterface.loadingRfrOrdSave]: 'loading (018)',
    [i18nInterface.loadingRfrSave]: 'loading (019)',
    [i18nInterface.loadingSharedAdviseLocation]: 'loading (020)',
    [i18nInterface.loadingSharedAuthCall]: 'loading (021)',
    [i18nInterface.loadingSharedContainerMultiple]: 'loading (022)',
    [i18nInterface.loadingSharedContainerSearch]: 'loading (023)',
    [i18nInterface.loadingSharedContainerSingle]: 'loading (024)',
    [i18nInterface.loadingSharedDepot]: 'loading (025)',
    [i18nInterface.loadingInfChangeDepot]: 'changing depot',
    [i18nInterface.loadingSharedEquipments]: 'loading (026)',
    [i18nInterface.loadingSharedGetDepot]: 'loading (027)',
    [i18nInterface.loadingSharedGetEquipment]: 'loading (028)',
    [i18nInterface.loadingSetDepot]: 'loading (029)',
    [i18nInterface.loadingSetEquipment]: 'loading (030)',
    [i18nInterface.loadingApsGet]: 'loading (031)',
    [i18nInterface.loadingEqsDetail]: 'loading (032)',
    [i18nInterface.loadingEqsGet]: 'loading (033)',
    [i18nInterface.loadingQuaGet]: 'loading (034)',
    [i18nInterface.loadingPage]: 'loading page',
    [i18nInterface.loadingDshGet]: 'loading (036)',
    [i18nInterface.loadingChgSave]: 'loading (037)',
    [i18nInterface.loadingInfLocationHistory]: 'loading (038)',
    [i18nInterface.loadingOrdDetailsSecondary]: 'loading (039)',
    [i18nInterface.loadingEnvironmentInfo]: 'connecting / loading environment info',
    [i18nInterface.loadingStatsAction]: 'update logging',
    [i18nInterface.loadingStatsConnect]: 'log connection',
    [i18nInterface.loadingStatsVersionCheck]: 'version check',
    [i18nInterface.textNewOrderAvailable]: 'new order available',
    [i18nInterface.textLiveUpdate]: 'live update',
    [i18nInterface.textPatch]: 'patch',
    [i18nInterface.textSoftpakRelease]: 'softpak release',
    [i18nInterface.textAppChannel]: 'app channel',
    [i18nInterface.textCopiedToClipboard]: 'copied to clipboard',
    [i18nInterface.textOnlyMyOrders]: 'only my orders',
    [i18nInterface.textWeatherForecast]: 'weather forecast',
    [i18nInterface.textWeatherForecastRefreshed]: 'forecast refreshed',
    [i18nInterface.textMachineryStatus]: 'machinery status',
    [i18nInterface.textDone]: 'done',
    [i18nInterface.textUNNR]: 'UNNR',
    [i18nInterface.textIMO]: 'IMO',
    [i18nInterface.textPleaseSelect]: 'please select',
    [i18nInterface.textETA]: 'ETA',
    [i18nInterface.textDescription]: 'description',
    [i18nInterface.textIMOFlashpoint]: 'flashpoint',
    [i18nInterface.textIMOKemlerGroupcode]: 'kemler groupcode',
    [i18nInterface.textIMOUnnoCode]: 'unno code',
    [i18nInterface.textClass]: 'class',
    [i18nInterface.textLocationHistory]: 'location history',
    [i18nInterface.textRevertSetOnOnTruck]: 'revert set on truck',
    [i18nInterface.textShow]: 'show',
    [i18nInterface.textHide]: 'hide',
    [i18nInterface.textIMOLine]: 'IMO Line',
    [i18nInterface.textSetOnTruck]: 'is set on truck? (can be reverted)',
    [i18nInterface.textDelivered]: 'delivered',
    [i18nInterface.textBooked]: 'booked',
    [i18nInterface.textReserved]: 'reserved',
    [i18nInterface.textBody]: 'body',
    [i18nInterface.textEstimateHours]: 'estimate hours',
    [i18nInterface.textLoadingLists]: 'loading lists',
    [i18nInterface.textQueryingXMightTakeAWhile]: 'querying {{x}} might take a while',
    [i18nInterface.textFilters]: 'filters',
    [i18nInterface.textLoadingList]: 'loading list',
    [i18nInterface.textRelocateToQuay]: 'relocate to quay',
    [i18nInterface.textContainerStatusGroup]: 'container status group',
    [i18nInterface.textPage]: 'page',
    [i18nInterface.textNext]: 'next',
    [i18nInterface.textPrevious]: 'previous',
    [i18nInterface.textAboutTheContainer]: 'about the container',
    [i18nInterface.textIncoming]: 'incoming',
    [i18nInterface.textOutgoing]: 'outgoing',
    [i18nInterface.textRepair]: 'repair',
    [i18nInterface.textTerminalAbbr]: 'term.',
    [i18nInterface.textStowLocationAbbr]: 'stow loc.',
    [i18nInterface.textShuffles]: 'shuffles',
    [i18nInterface.textWeight]: 'weight',
    [i18nInterface.textLicensePlate]: 'license plate',
    [i18nInterface.textChangeDetails]: 'change details',
    [i18nInterface.textTonsTested]: 'tons tested',
    [i18nInterface.textDashboards]: 'dashboards',
    [ctrlAboutTheContainer]: 'About the container',
    [ctrlAdviseLocation]: 'Advise location',
    [ctrlCarriagePosition]: 'Wagon position',
    [ctrlCarriage]: 'Wagon',
    [ctrlCassetteCode]: 'MAFI/Cassette code',
    [ctrlIsCassette]: 'Link to MAFI/Cassette instead',
    [ctrlConstructionDate]: 'Construction date',
    [ctrlContainerLength]: 'Container length',
    [ctrlContainerNumber]: 'Container number',
    [ctrlContainerPrefix]: 'Container prefix',
    [ctrlContainerSearch]: 'Container search',
    [ctrlContainerSize]: 'Container size',
    [ctrlContainerSummary]: 'Container summary',
    [ctrlCopyFromBooking]: 'Copy from booking',
    [ctrlDefrostInterval]: 'Defrost interval',
    [ctrlDrains]: 'Drains',
    [ctrlEditValues]: 'Edit values',
    [ctrlExtraPti]: 'Extra PTI?',
    [ctrlGrossWeightDeviation]: 'Gross weight deviation',
    [ctrlGrossWeight]: 'Gross weight',
    [ctrlHumidity]: 'Humidity',
    [ctrlLocation]: 'Location',
    [ctrlNewLocation]: 'New location',
    [ctrlCassetteLocation]: 'New MAFI/Cassette location',
    [ctrlPortOfDischarge]: 'Port of discharge',
    [ctrlReeferChecks]: 'Reefer settings',
    [ctrlReeferTemperatureMax]: 'Max. temperature',
    [ctrlReeferTemperatureMin]: 'Min. temperature',
    [ctrlReeferTemperature]: 'Temperature',
    [ctrlRepairInfo]: 'Repair info',
    [ctrlSealNrTerminal]: 'Seal',
    [ctrlShowFilters]: 'Show filters',
    [ctrlSorting]: 'Sorting',
    [ctrlStowLocation]: 'Stow location',
    [ctrlPortOfDischargeTerminal]: 'port of discharge terminal',
    [ctrlVentilationUnit]: 'Ventilation unit',
    [ctrlVentilationValue]: 'Ventilation value',
    [ctrlVentilation]: 'Ventilation',
    [sectionActions]: 'Actions',
    [sectionAdviseLocation]: 'Advise location',
    [sectionContainerFilter]: 'Container filter',
    [sectionContainerList]: 'Container search',
    [sectionContainerNumber]: 'Container number',
    [sectionContainerSummary]: 'Container summary',
    [sectionEditValues]: 'Edit values',
    [sectionLocation]: 'Location',
    [sectionNewLocation]: 'New location',
    [sectionCassette]: 'MAFI/Cassette',
    [sectionCassetteCode]: 'MAFI/Cassette code',
    [sectionOrderDetails]: 'Order Details',
    [sectionReadonlyContainer]: 'Selected container',
    [sectionReeferChecks]: 'Reefer settings',
    [sectionRepairInfo]: 'Repair info',
    [sectionStowLocation]: 'Stow location',
    [sectionTrainCarriage]: 'Train wagon',
    [i18nInterface.text20Ft]: '20ft',
    [i18nInterface.text40Ft]: '40ft',
    [i18nInterface.textAccount]: 'account',
    [i18nInterface.textAdministrative]: 'Administrative',
    [i18nInterface.textAllocated]: 'allocated',
    [i18nInterface.textAppStoreVersion]: 'app store version',
    [i18nInterface.textAppointmentStats]: 'Appointment stats',
    [i18nInterface.textBack]: 'Back',
    [i18nInterface.textBarge]: 'Barge',
    [i18nInterface.textBlocked]: 'Blocked',
    [i18nInterface.textBodyRepair]: 'Body repair',
    [i18nInterface.textBooking]: 'Booking',
    [i18nInterface.textCategory]: 'Category',
    [i18nInterface.textChannel]: 'Channel',
    [i18nInterface.textCheckDigit]: 'check digit',
    [i18nInterface.textCheckingForUpdates]: 'Checking for updates',
    [i18nInterface.textCleaning]: 'Cleaning',
    [i18nInterface.textClear]: 'clear',
    [i18nInterface.textClose]: 'Close',
    [i18nInterface.textColor]: 'Color',
    [i18nInterface.textCompany]: 'company',
    [i18nInterface.textConfirmMove]: 'Confirm move',
    [i18nInterface.textConstruction]: 'construction',
    [i18nInterface.textContainerInfo]: 'Container info',
    [i18nInterface.textContainerNumber]: 'container number',
    [i18nInterface.textContainerStatus]: 'Container status',
    [i18nInterface.textContainer]: 'Container',
    [i18nInterface.textCassettesMafis]: 'Cassettes/MAFIs',
    [i18nInterface.textTrailer]: 'Trailer',
    [i18nInterface.textContainerType]: 'Container type',
    [i18nInterface.textCustomer]: 'Customer',
    [i18nInterface.textCustomerRelease]: 'Customs release',
    [i18nInterface.textDelivery]: 'Delivery',
    [i18nInterface.textDepot]: 'Term./Depot',
    [i18nInterface.textDeparture]: 'Est. departure',
    [i18nInterface.textDeveloperOptions]: 'developer options',
    [i18nInterface.textDischarge]: 'discharge',
    [i18nInterface.textDoUpdate]: 'update',
    [i18nInterface.textDownloadingUpdate]: 'Downloading the update: {{percentage}}%',
    [i18nInterface.textDropOff]: 'drop-off',
    [i18nInterface.textEmpty]: 'empty',
    [i18nInterface.textCancel]: 'cancel',
    [i18nInterface.textEnterLast4Digits]: 'enter last 4 digits to confirm.',
    [i18nInterface.textEquipmentStats]: 'Equipment stats',
    [i18nInterface.textQuayjobStats]: 'Quayjob stats',
    [i18nInterface.textEquipment]: 'Equipment',
    [i18nInterface.textErrorBadGateway]: `Please try again in 5 minutes, thereafter: please contact Softpak. Mention the page, and the error code: 502.`,
    [i18nInterface.textErrorCantCheckForUpdate]: `Can't check for update`,
    [i18nInterface.textErrorDeviceIsOffline]: `Could not load. Please check your internet connection. If this problem persists, please contact helpdesk@softpak.nl.`,
    [i18nInterface.textErrorFailedToFetch]: `Failed to fetch`,
    [i18nInterface.textErrorHttpFailure]: 'could not make connection',
    [i18nInterface.textErrorInFrontend]: '',
    [i18nInterface.textErrorInvalidValue]: 'has an invalid value',
    [i18nInterface.textErrorMandatory]: 'is a mandatory field',
    [i18nInterface.textErrorNoResultsFound]: 'No results found',
    [i18nInterface.textErrorNotImplemented]: `Please contact Softpak. Mention the page, and the error code: 501.`,
    [i18nInterface.textErrorOrderTypeNotSupported]: `Order Type "{{ transactionType }} ({{status}})" is not yet supported by the app. Please contact Softpak.`,
    [i18nInterface.textErrorSignInConnectionError]: 'Sign in: connection error',
    [i18nInterface.textErrorTokenExpired]: 'The session has expired.',
    [i18nInterface.textErrorTooHigh]: 'has a value that is too high (must be at least: {{required}})',
    [i18nInterface.textErrorTooLong]: 'has a value that is too long (required length: {{required}})',
    [i18nInterface.textErrorTooLow]: 'has a value that is too low (must be at least: {{required}})',
    [i18nInterface.textErrorTooShort]: 'has a value that is too short (required length: {{required}})',
    [i18nInterface.textErrorUnexpectedInBackend]: 'unknown error',
    [i18nInterface.textErrorWhileUpdatingApp]: 'Update failed',
    [i18nInterface.textErrorWrongCredentials]: 'Please check your username and password.',
    [i18nInterface.textAlreadyLocatedMessage]: `This order is already allocated to {{ allocatedUser }}. Do you still want to proceed?`,
    [i18nInterface.textLinkedCassetteLinkedToX]: `MAFI/Cassette <strong>{{ cassetteCode }}</strong> is linked to <strong>{{ containerList }}</strong>`,
    [i18nInterface.textCassetteWithContainersCannotBeLinked]: 'A MAFI/Cassette with containers on top cannot be linked.',
    [i18nInterface.textCassetteWithContainersCannotBeLinkedTitle]: 'Bundling not possible',
    [i18nInterface.textCassetteWithContainersCannotBeLinkedContent]: 'Bundling is not available when there are containers on the MAFI/Cassette.',
    [i18nInterface.textAlreadyLocated]: `Already allocated`,
    [i18nInterface.textAdviseLocation]: `Advise location`,
    [i18nInterface.textFilter]: 'Filter',
    [i18nInterface.textEditFilters]: 'edit filters',
    [i18nInterface.textFinalPort]: 'Final port',
    [i18nInterface.textFinishedUpdating]: 'Update finished',
    [i18nInterface.textFullEmpty]: 'Full / Empty',
    [i18nInterface.textFull]: 'full',
    [i18nInterface.textHelloWorld]: 'Hello world',
    [i18nInterface.textHome]: 'Home',
    [i18nInterface.textInformation]: 'information',
    [i18nInterface.textInternal]: 'Internal',
    [i18nInterface.textLiftOfTruck]: 'Lift of truck',
    [i18nInterface.textLoad]: 'load',
    [i18nInterface.textLoading]: 'loading',
    [i18nInterface.textLocation]: 'location',
    [i18nInterface.textMafiCassetteSuccessfullyLoaded]: 'MAFI/Cassette {{ cassetteCode }} succesfully loaded.',
    [i18nInterface.textMachineryRepair]: 'Machinery repair',
    [i18nInterface.textMachinery]: 'machinery',
    [i18nInterface.textMiscellaneous]: 'Miscellaneous',
    [i18nInterface.textModality]: 'modality',
    [i18nInterface.textNextVersion]: 'next version',
    [i18nInterface.textNoCustomsRelease]: 'No customs release',
    [i18nInterface.textNoResults]: 'no results',
    [i18nInterface.textNoResultsForSearch]: 'No result found for search: {{searchRequest}}',
    [i18nInterface.textNoUpdatesAvailable]: 'No updates available',
    [i18nInterface.textNo]: 'no',
    [i18nInterface.textNonReefer]: 'non-reefer',
    [i18nInterface.textNotBlocked]: 'Not blocked',
    [i18nInterface.textNotReleased]: 'Not released',
    [i18nInterface.textOrder]: 'order',
    [i18nInterface.textOrders]: 'Orders',
    [i18nInterface.textOtherErrors]: 'other errors',
    [i18nInterface.textPassword]: 'password',
    [i18nInterface.textPickup]: 'pick-up',
    [i18nInterface.textPlaceInStack]: 'Place in stack',
    [i18nInterface.textPlaceOnTruck]: 'Place on truck',
    [i18nInterface.textPrefix]: 'prefix',
    [i18nInterface.textPort]: 'Port',
    [i18nInterface.textPti]: 'PTI',
    [i18nInterface.textQuayjob]: 'Quayjob',
    [i18nInterface.textQuayjobs]: 'Quayjobs',
    [i18nInterface.textRail]: 'Rail',
    [i18nInterface.textReachedTheLocation]: 'Reached the location',
    [i18nInterface.textRedelivery]: 'Redelivery',
    [i18nInterface.textReefer]: 'reefer',
    [i18nInterface.textReeferHeating]: 'reefer/heating',
    [i18nInterface.textReefers]: 'reefers',
    [i18nInterface.textRefurbishing]: 'Refurbishing',
    [i18nInterface.textRelease]: 'release',
    [i18nInterface.textReleased]: 'Release',
    [i18nInterface.textRelocate]: 'relocate',
    [i18nInterface.textRoroLoad]: 'Roro load',
    [i18nInterface.textRemarks]: 'Remarks',
    [i18nInterface.textBundleToCassette]: 'Create a MAFI/Cassette bundle',
    [i18nInterface.textAddCassette]: 'Add MAFI/Cassette',
    [i18nInterface.textReserveQuay]: 'Reserve quay',
    [i18nInterface.textReset]: 'Reset',
    [i18nInterface.textSave]: 'Save',
    [i18nInterface.textSaving]: 'Saving',
    [i18nInterface.textSearch]: 'search',
    [i18nInterface.textSettings]: 'Settings',
    [i18nInterface.textSignIn]: 'sign in',
    [i18nInterface.textSignOut]: 'Sign out',
    [i18nInterface.textSize]: 'size',
    [i18nInterface.textTerminal]: 'Terminal',
    [i18nInterface.textTransactionType]: 'transaction type',
    [i18nInterface.textTruck]: 'Truck',
    [i18nInterface.textTruckStats]: 'trucks on site',
    [i18nInterface.textTrucksOnSite]: 'trucks on site',
    [i18nInterface.textAvgWaitingTime]: 'avg. waiting time',
    [i18nInterface.textMaxWaitingTime]: 'max. waiting time',
    [i18nInterface.textLast30Min]: 'last 30 min',
    [i18nInterface.textNotEnoughDataYet]: 'not enough data yet',
    [i18nInterface.textMinutes]: 'min',
    [i18nInterface.text30MinAgo]: '30 min ago',
    [i18nInterface.textNow]: 'now',
    [i18nInterface.textCompletedTrucks]: 'exited gate',
    [i18nInterface.textAppearedTrucks]: 'entered gate',
    [i18nInterface.textAvgTurnAroundTime]: 'turn around',
    [i18nInterface.textUnexpectedError]: 'Something went wrong',
    [i18nInterface.textUpdate]: 'Update',
    [i18nInterface.textUsername]: 'username',
    [i18nInterface.textVersion]: 'Version',
    [i18nInterface.textVessel]: 'vessel',
    [i18nInterface.textWelcome]: 'Welcome',
    [i18nInterface.textYes]: 'yes',
    [i18nInterface.textYouHaveBeenSignedIn]: 'You have been signed in',
    [i18nInterface.textYouHaveBeenSignedOut]: 'You have been signed out',
    [i18nInterface.textAddTar]: 'add tar',
    [i18nInterface.textDefrosting]: 'defrosting',
    [i18nInterface.textPostpone]: 'postpone',
    [i18nInterface.textReeferMonitoring]: 'reefer monitoring',
    [i18nInterface.textConnectPlanning]: 'connect planning',
    [i18nInterface.textResultsShownUntil]: 'results shown until {{date}}',
    [i18nInterface.textStackLocation]: 'stack location',
    [i18nInterface.textStack]: 'stack',
    [i18nInterface.textTar]: 'tar',
    [i18nInterface.textTemperature]: 'temperature',
    [i18nInterface.textUpdateAvailable]: 'update available',
    [i18nInterface.textSetpoint]: 'setpoint',
    [i18nInterface.textSubcustomer]: 'subcustomer',
    [i18nInterface.textExport]: 'export',
    [i18nInterface.textSubmit]: 'Submit',
    [i18nInterface.textControlledAtmosphere]: 'contr. atmsp.',
    [i18nInterface.textImport]: 'import',
    [i18nInterface.textVerificationCode]: 'verification code',
    [i18nInterface.textView]: 'view',
    [i18nInterface.textWouldYouLikeToUpdate]: 'would you like to update?',
    [i18nInterface.textStats]: 'statistics',
    [i18nInterface.textKioskMode]: 'kiosk mode',
    [i18nInterface.textStart]: 'start',
    [i18nInterface.textStop]: 'stop',
    [ctrlEnableAppointmentStats]: 'appointment stats',
    [ctrlEnableEquipmentStats]: 'equipment stats',
    [ctrlEnableOrders]: 'orders',
    [ctrlEnableQuayjobs]: 'quayjobs',
    [i18nInterface.textReeferOrders]: 'reefer orders',
    [i18nInterface.textErrorEndpointNotFound]: 'Endpoint doesn\'t exist',
    [i18nInterface.textChange]: 'change',
    [i18nInterface.textChangeDepot]: 'change depot',
    [i18nInterface.textNewDepot]: 'new depot',
    [i18nInterface.textAreYouSure]: 'Are you sure?',
    [sectionRegistration]: 'Registration',
    [i18nInterface.textProcessed]: 'processed',
    [i18nInterface.textNotProcessed]: 'not processed',
    [i18nInterface.textAnd]: 'and',
    [i18nInterface.textType]: 'type',
    [i18nInterface.textConnect]: 'connect',
    [i18nInterface.textDisconnect]: 'disconnect',
    [i18nInterface.textOnReeferLocation]: 'on reefer location',
    [i18nInterface.textHeathingType]: 'heathing type',
    [i18nInterface.textElectricity]: 'electricity',
    [i18nInterface.textWater]: 'water',
    [i18nInterface.textSteam]: 'steam',
    [i18nInterface.textShowOnlyDisconnected]: 'show only disconnected',
    [i18nInterface.textBundledCassettesLinkedToCassette]: 'All MAFI/Cassettes in this bundle',
    [i18nInterface.textBundle]: 'Bundle',
    [i18nInterface.textContainersLinkedToCassette]: 'Containers on top',
    [i18nInterface.textStowLocation]: 'stow location',
    [i18nInterface.textTempDeviation]: 'max. dev.',
    [i18nInterface.textInfo]: 'info',
    [i18nInterface.textStockInfo]: 'stock info',
    [i18nInterface.txtYouCanChangeYourFilters]: 'you can change the filters',
    [sectionFilters]: 'filters',
    [i18nInterface.textNotAllocated]: 'not allocated',
    [i18nInterface.textSelect]: 'select',
    [i18nInterface.textLinkToCassette]: 'Link to MAFI/Cassette',
    [i18nInterface.textAddOtherCassetteAndMakeBundle]: 'Add another MAFI/Cassette and make a bundle',
    [i18nInterface.textAddAnotherCassetteToBundle]: 'Add or remove MAFI/Cassettes from this bundle',
    [i18nInterface.textUnlinkCassette]: 'Unlink MAFI/Cassette',
    [i18nInterface.textUnlinkCassetteAndRelocate]: 'Unlink MAFI/Cassette and relocate container',
    [i18nInterface.textCassetteContainerActionSingleRelocate]: 'The container and the MAFI/Cassette will be relocated.',
    [i18nInterface.textCassetteContainerActionSingleLoad]: 'The container and the MAFI/Cassette will be loaded.',
    [i18nInterface.textCassetteIsPartOfBundle]: 'You are viewing a bundle of MAFI/Cassettes.',
    [i18nInterface.textMasterCassetteShownBecauseBundle]: 'This MAFI/Cassette is part of a bundle, therefore the master MAFI/Cassette is shown.',
    [i18nInterface.textMasterCassetteFootnote]: 'Indicates the master MAFI/Cassette.',
    [i18nInterface.textCassetteContainerAction]: 'There is a MAFI/Cassette linked to this container. This means that all containers linked to this MAFI/Cassette will execute the same action. Review them below.',
    [i18nInterface.textCassette]: 'MAFI/Cassette',
    [i18nInterface.textBundledCassette]: 'Bundled MAFI/Cassette',
    [i18nInterface.textLoadingBundledCassette]: 'Loading bundled MAFI/Cassettes',
    [i18nInterface.textLoadBundledCassettes]: 'Load bundled MAFI/Cassettes',
    [i18nInterface.textContainersLinkedToCassetteCode]: 'Containers linked to MAFI/Cassette code',
    [i18nInterface.textValidCassette]: 'This is a valid MAFI/Cassette.',
    [i18nInterface.textSelectedContainer]: '(Currently selected container)',
    [i18nInterface.textUnitId]: 'Unit ID',
    [i18nInterface.textUnitInfo]: 'Unit Info',
    [i18nInterface.textUnit]: 'Unit',
    [i18nInterface.textUnitType]: 'Unit type',
    [i18nInterface.textTrailerId]: 'Trailer ID',
    [textNewSearch]: 'new search',
    [textNotSet]: 'not set',
  };
}
